// extracted by mini-css-extract-plugin
module.exports = {"textStyling":"ErrorBoundary_textStyling__2E6lr","errorImageStyle":"ErrorBoundary_errorImageStyle__3ZgIh","logoStyling":"ErrorBoundary_logoStyling__3ZU7-"};